import { fetchData, isNull } from "App/utils/helpers";
import { useState } from "react";
import { useEffect } from "react";

/**
 * @param {Array<string>} urls - this is a array
 * @property {string} url api call url
 * @property {string} key object key
 * @property {boolean} search with search or not different on default value
 * @property {string} type_instance what's instance use, variable/constants
 * @property {string} options options for option on axios
 * @property {string} type_response enum, body or data
 * @property {string} value value key based on response api
 * @property {Array} label array
 * @property {Array} attr_addition array maksimal 2
 * @property {Array} attr_addition_value array maksimal 2
 *
 *
 * @returns infoData berisi value dan label yang sudah valid
 */

function useMultipleSelect(urls) {
  const [infoData, setInfoData] = useState([]);

  async function multipleApiCall() {
    const _temp = [];
    const promises = urls.map((item) =>
      fetchData(item.type_instance, item.url, item.type_response, item?.options, item?.sub_type_response)
    );

    await Promise.all(promises).then((responses) => {
      responses.map((item, index) => {
        const _tempOption = defaultOption(urls[index]["search"]);
        item.map((item2) => {
          return validAttrAddition(_tempOption, item2, index);
        });
        return _temp.push({
          key: urls[index]["key"],
          data: _tempOption,
        });
      });
    });
    setInfoData(_temp);
  }

  /**
   *
   * @param {Array} arr
   * @param {Object} item2
   * @param {Number} index
   *
   * pada func ini masih manual untuk tambahan attribut
   * dan maksimal attribute adalah 2
   *
   * @returns
   */

  const validAttrAddition = (arr, item2, index) => {
    const addition = urls[index]["attr_addition"];
    const additionValue = urls[index]["attr_addition_value"];

    if (isNull(addition)) {
      return arr.push({
        value: item2[urls[index]["value"]],
        label: validLabelArray(urls, item2, index),
      });
    } else {
      if (addition.length === 1) {
        return arr.push({
          value: item2[urls[index]["value"]],
          label: validLabelArray(urls, item2, index),
          [addition[0]]: item2[additionValue[0]],
        });
      } else if (addition.length === 2) {
        return arr.push({
          value: item2[urls[index]["value"]],
          label: validLabelArray(urls, item2, index),
          [addition[0]]: item2[additionValue[0]],
          [addition[1]]: item2[additionValue[1]],
        });
      } else if (addition.length === 3) {
        return arr.push({
          value: item2[urls[index]["value"]],
          label: validLabelArray(urls, item2, index),
          [addition[0]]: item2[additionValue[0]],
          [addition[1]]: item2[additionValue[1]],
          [addition[2]]: item2[additionValue[2]],
        });
      }
    }
  };

  useEffect(() => {
    multipleApiCall();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return infoData;
}

const validLabelArray = (urls, item2, index) => {
  let _temp = "";
  const label = urls[index]["label"];
  if (label.length === 1) {
    return (_temp = `${item2[label[0]]}`);
  } else if (label.length === 2) {
    return (_temp = `${item2[label[0]]} | ${item2[label[1]]}`);
  }
  return _temp;
};

const defaultOption = (status) => {
  return status
    ? []
    : [
        {
          label: "Pilih",
          value: "",
        },
      ];
};

export const validasiMultipleSelect = (arr, idx) => {
  return arr.length > 0 ? arr[idx].data : [];
};

export default useMultipleSelect;
